module.exports = __webpack_public_path__ + "img/ios_sms.a424014.svg";